import { h } from 'vue'
import { HomeIcon, PlusCircleIcon, XCircleIcon, CheckCircleIcon,HomeModernIcon, UserGroupIcon, ChevronDownIcon, } from "@heroicons/vue/24/solid";
export const active = [
	{
		value: '1',
		label: 'Active',
		icon: h(CheckCircleIcon),
	},
	{
		value: '0',
		label: 'Not Active',
		icon: h(XCircleIcon),
	},
]

export const disabled = [
	{
		value: '1',
		label: 'Disabled',
		icon: h(XCircleIcon),
	},
	{
		value: '0',
		label: 'Not Disabled',
		icon: h(CheckCircleIcon),
	},
]
